import { RECEIVED_BANNER } from '../actions/GetMessageBanner';
import { USER_RECEIVED } from '../actions/GetUser';

const initialState = [];
const pendingUserBanner = {
    reference: 'is_vendor_pending',
    type: 'warning',
    title: 'Your account is awaiting moderation',
    body: 'We aim to approve new accounts with 24 hours but some features may be limited in the meantime',
    closeable: false,
};

const addOrReplaceBanner = (state, banner) => {
    const existingBanner = state.filter(searchBanner => banner.reference === searchBanner.reference).length > 0;
    if (!existingBanner) {
        return [...state, banner];
    }
    return state.map(searchBanner =>
        (searchBanner.reference === banner.reference) ? banner : searchBanner
    );
};

export default (state = initialState, action) => {
    switch (action.type) {
        case RECEIVED_BANNER:
            return addOrReplaceBanner(state, action.messageBanner);
        case USER_RECEIVED:
            const isUserPending = action.user.is_vendor_pending;
            const existingBanner = state.filter(banner => banner.reference === 'is_vendor_pending').length > 0;
            if (isUserPending && !existingBanner) {
                return [...state, pendingUserBanner];
            }
            if (!isUserPending && existingBanner) {
                return state.filter((banner) => banner.reference !== 'is_vendor_pending');
            }
            return state;
        default:
            return state;
    }
};
